if (!customElements.get('magdor-product-family')) {
  customElements.define('magdor-product-family', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => {
        if (event.target.tagName !== 'SELECT') return;
        const option = event.target.selectedOptions[0];
        if (!option) return;
        if (this.dataset.context !== 'card') {
          window.location.assign(option.value);
          return;
        }
        const card = this.closest('.mr-card');
        if (!card) return;
        const image = card.querySelector('.mr-image img');
        if (image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          image.alt = option.dataset.title;
        }
        card.querySelectorAll('.mr-image, h2 a').forEach(link => { link.href = option.value; });
        const price = card.querySelector('.mr-price');
        if (price) price.textContent = option.dataset.money;
        let state = card.querySelector('.mr-state');
        if (!state) {
          state = document.createElement('p');
          state.className = 'mr-state';
          this.before(state);
        }
        state.textContent = this.dataset.unavailable;
        state.hidden = option.dataset.available === 'true';
        card.dataset.price = option.dataset.price;
        card.dispatchEvent(new CustomEvent('magdor:family-change', { bubbles: true }));
      });
    }
  });
}
